var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('skeleton-loader',{staticClass:"loading-card",attrs:{"type":"table-heading, article, article"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }